export default () => {
  // Dropdown main navigation
  const nav = document.querySelector('.main-nav__list');
  const allLinks = nav.querySelectorAll('a');
  const parents = nav.querySelectorAll('.main-nav__list-item--has-dropdown');
  const subMenuLinks = nav.querySelectorAll('.main-nav__dropdown a');

  const activeClass = 'nav-hover';
  const focusClass = 'nav-focus';

  const touchBodyHandler = (e) => {
    const el = e.currentTarget;
    // eslint-disable-next-line no-use-before-define
    hideDropdown(el);
  };

  const showDropdown = (el) => {
    el.classList.add(activeClass);

    setTimeout(() => {
      document.body.addEventListener('touchstart', touchBodyHandler);
    }, 250);
  };

  const hideDropdown = (el) => {
    el.classList.remove(activeClass);
    document.body.removeEventListener('touchstart', touchBodyHandler);
  };

  const addFocus = (el) => {
    el.classList.add(focusClass);
  };

  const removeFocus = () => {
    const focusEl = nav.querySelectorAll(`.${focusClass}`);
    focusEl.forEach((item) => {
      item.classList.remove(focusClass);
    });
  };

  const handleFocus = (el) => {
    const parent = el.parentElement;

    if (parent.classList.contains('main-nav__list-item')) {
      removeFocus();
      addFocus(el);
    } else {
      const newFocus = el
        .closest('.main-nav__list-item--has-dropdown')
        .querySelector('.main-nav__link');

      addFocus(newFocus);
    }
  };

  // Handlers
  const mouseoverHandler = (e) => {
    const el = e.currentTarget;

    if (!el.classList.contains(activeClass)) {
      e.preventDefault();
    }

    showDropdown(el, activeClass);
  };

  const mouseoutHandler = (e) => {
    hideDropdown(e.currentTarget);
  };

  parents.forEach((item) => {
    item.addEventListener('mouseover', mouseoverHandler);
    item.addEventListener('touchstart', mouseoverHandler);
    item.addEventListener('mouseout', mouseoutHandler);
  });

  subMenuLinks.forEach((link) => {
    link.addEventListener('touchstart', (e) => {
      // Prevent touchstart on body from firing instead of link
      e.stopImmediatePropagation();
    });
  });

  allLinks.forEach((link) => {
    link.addEventListener('focus', (e) => {
      handleFocus(e.currentTarget);
    });
  });

  // Modal nav
  const subnavActive = 'mobile-nav__subnav-toggle--active';
  [...document.querySelectorAll('.mobile-nav__list-item--has-subnav')].forEach((wrapper) => {
    const trigger = wrapper.querySelector('.mobile-nav__subnav-toggle');
    const content = wrapper.querySelector('.mobile-nav__subnav');

    if (content.classList.contains('mobile-nav__subnav--opened')) {
      content.style.height = `${content.scrollHeight}px`;
    }

    trigger.addEventListener('click', () => {
      if (!trigger.classList.contains(subnavActive)) {
        trigger.classList.add(subnavActive);
        content.style.height = `${content.scrollHeight}px`;

        if (trigger.classList.contains('mobile-nav__subnav-toggle--level3')) {
          const parentWrapper = wrapper.parentElement;
          if (parentWrapper.classList.contains('mobile-nav__subnav')) {
            parentWrapper.style.height = `${parentWrapper.scrollHeight + content.scrollHeight}px`;
          }
        }
      } else {
        trigger.classList.remove(subnavActive);

        if (trigger.classList.contains('mobile-nav__subnav-toggle--level3')) {
          const parentWrapper = wrapper.parentElement;

          if (parentWrapper.classList.contains('mobile-nav__subnav')) {
            parentWrapper.style.height = `${parentWrapper.scrollHeight - content.scrollHeight}px`;
          }
        }

        content.style.height = 0;
      }
    });
  });

  // Collapse header on scroll
  let lastScrollTop = 0;
  const header = document.querySelector('.page-header');

  document.addEventListener('scroll', () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      header.classList.add('collapsed');
    }
    if (st < 100) {
      header.classList.remove('collapsed');
    }
    lastScrollTop = st;
  });
};
